"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.formatLink = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var formatLink = function formatLink(link) {
  var parsedUrl = (0, _urlParse["default"])(link);

  if (parsedUrl.protocol === 'tel:' || parsedUrl.protocol === 'mailto:') {
    return link;
  }

  if (!/^(?:f|ht)tps?\:\/\//.test(link)) {
    return "http://".concat(link);
  }

  return link;
};

exports.formatLink = formatLink;
var _default = formatLink;
exports["default"] = _default;